import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpService } from './http.service';

/** Crypto custodial wallets (BitGo root + receive addresses) via MVP. */
@Injectable({ providedIn: 'root' })
export class BitgoService {
  constructor(private http: HttpService) {}

  listWallets(
    clientId?: number | string,
    opts?: { tree?: boolean; includeBalances?: boolean },
  ): Observable<any> {
    let params = new HttpParams();
    if (clientId != null) params = params.set('client_id', String(clientId));
    if (opts?.tree === false) params = params.set('tree', 'false');
    if (opts?.includeBalances) params = params.set('include_balances', 'true');
    return this.http.get('crypto-wallet', params);
  }

  getWallet(userSubwalletId: number | string): Observable<any> {
    return this.http.get(`crypto-wallet/${userSubwalletId}`);
  }

  getBalances(userSubwalletId: number | string): Observable<any> {
    return this.http.get(`crypto-wallet/${userSubwalletId}/balances`);
  }

  provision(body: {
    user_id?: number | string;
    client_id?: number | string;
    owner_user_id?: number | string;
    create_root?: boolean;
    network?: string;
    wallet_kind?: string;
    label?: string;
    force?: boolean;
    wallet_key?: string;
    root_key?: string;
    purpose?: string;
    card_id?: string | number;
    virtual_card_id?: string | number;
  }): Observable<any> {
    return this.http.post('crypto-wallet/provision', body);
  }

  updateLabel(
    userSubwalletId: number | string,
    label: string,
  ): Observable<any> {
    return this.http.patch(`crypto-wallet/${userSubwalletId}`, { label });
  }

  deactivate(userSubwalletId: number | string): Observable<any> {
    return this.http.delete(`crypto-wallet/${userSubwalletId}`);
  }
}
